module.exports = __webpack_public_path__ + "static/img/bg_1.d8b2aef4.png";